import { Link, useNavigate } from 'react-router-dom';
import { Img } from 'react-image';
import { Button, Navbar } from 'flowbite-react';
import { useThemeContext } from 'src/context/ThemeProvider';

const SessionEndedScreen = () => {
	const navigate = useNavigate();
	const { themeMode } = useThemeContext();
	return (
		<div className="h-screen w-screen dark:text-white">
			<Navbar
				className={`w-full rounded-none !px-[45px] sm:!px-[10px] bg-white dark:bg-[#18222D]`}
				fluid={true}
				rounded={true}
			>
				<div className="flex items-center gap-8 ">
					<Link to="/" className="flex items-center ">
						<Img
							loading="lazy"
							src={
								themeMode === 'dark'
									? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
									: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Levelup-Logo.png'
							}
							width="110"
							height="32px"
							alt="LevelUp Logo"
						/>
					</Link>
				</div>
			</Navbar>
			<div className="my-60 flex flex-col items-center justify-center gap-2 dark:text-white">
				<p className=" text-2xl font-bold">Session has ended</p>
				<p className=" text-base">The session has ended by the host.</p>
				<Button
					onClick={() => {
						// navigate(`/dashboard`);
						navigate('/my-applications');
					}}
					color="purplePlaced"
					className="w-fit mt-[20px] font-[500] text-[14px] leading-[21px]"
				>
					Go Back to Dashboard
				</Button>
			</div>
		</div>
	);
};

export default SessionEndedScreen;
